import templateUrl from 'emun.customer/customer-open-orders.htm'
import AutoQuery from 'servicestack/auto-query/auto-query'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import orderConfig from 'emun.order/order.config';
import PrintOrderOptions from "emun.order/order-print";

class CustomerOpenOrdersController {
  constructor($rootScope) {
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.orderConfig = orderConfig;
    $ctrl.views = {
      list: "th-list",
      cards: "th"
    };
    console.info("cust open order", $ctrl.status, $ctrl.customerId);
    $ctrl.view = "list";
    var statusFilter = "StatusIn=Open";
    if ($ctrl.status && $ctrl.status != "") {
      statusFilter = "StatusIn=" + $ctrl.status;
    }
    $ctrl.openOrders = new AutoQuery({
      url: 'QueryCartsJoin.json?' + statusFilter + '&RetailerId=' + $ctrl.customerId,
      orderBy: '-OrderedOn',
      autoLoad: true,
      pageSize: $ctrl.view == 'list' ? 10 : 1000,
      scrollTop: false
    })
  }
  setView(view) {
    let $ctrl = this;
    $ctrl.view = view;
    if ($ctrl.view == 'list') $ctrl.openOrders.pageSize = 10;
    else if ($ctrl.view == 'cards') $ctrl.openOrders.pageSize = 1000;
    $ctrl.openOrders.load();
  }
  createOrder(model) {
    const $ctrl = this;
    $ctrl.$cart.createPrompt({
      retailer: $ctrl.customer,
      mode: $ctrl.mode,
      status: $ctrl.mode === "Quote" ? "Quote" : "Cart"
    });
  }
  printOrder(order) {
    const $ctrl = this;
    return PrintOrderOptions({
      request: {
        id: order,
        IncludeImages: false,
        IncludeBarcodes: false,
        OrderBy: "strProductID"
      }
    });
  }
}

let CustomerOpenOrders = {
  bindings: {
    customerId: '@',
    status: '@'
  },
  controller: CustomerOpenOrdersController,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl
  }
}

export default CustomerOpenOrders